export const imageCropperData = [
    {
        text:"Use The Image Cropper.ts"
    }
]